// Notification sound - short chime generated via AudioContext
let audioCtx = null;

export const playNotificationSound = () => {
  try {
    if (!audioCtx) audioCtx = new (window.AudioContext || window.webkitAudioContext)();
    const osc = audioCtx.createOscillator();
    const gain = audioCtx.createGain();
    osc.connect(gain);
    gain.connect(audioCtx.destination);

    osc.type = 'sine';
    osc.frequency.setValueAtTime(880, audioCtx.currentTime);      // A5
    osc.frequency.setValueAtTime(1100, audioCtx.currentTime + 0.1); // C#6
    osc.frequency.setValueAtTime(1320, audioCtx.currentTime + 0.2); // E6

    gain.gain.setValueAtTime(0.3, audioCtx.currentTime);
    gain.gain.exponentialRampToValueAtTime(0.01, audioCtx.currentTime + 0.4);

    osc.start(audioCtx.currentTime);
    osc.stop(audioCtx.currentTime + 0.4);
  } catch (_) {}
};

// Request browser notification permission
export const requestNotificationPermission = async () => {
  if (!('Notification' in window)) return false;
  if (Notification.permission === 'granted') return true;
  if (Notification.permission === 'denied') return false;
  const result = await Notification.requestPermission();
  return result === 'granted';
};

// Show browser notification (works when tab is hidden/minimized)
export const showBrowserNotification = (title, body, onClick) => {
  if (!('Notification' in window) || Notification.permission !== 'granted') return;

  const notification = new Notification(title, {
    body,
    icon: '/logo.png',
    badge: '/logo.png',
    tag: 'new-message', // replaces previous notification with same tag
    renotify: true,
  });

  notification.onclick = () => {
    window.focus();
    notification.close();
    if (onClick) onClick();
  };

  // Auto close after 5 seconds
  setTimeout(() => notification.close(), 5000);
};

// Check if page is hidden (minimized or different tab)
export const isPageHidden = () => {
  return document.hidden || document.visibilityState === 'hidden';
};
